import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeGoogle } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await exchangeGoogle(m[1]);
        const dest = u?.role === "admin" ? "/admin" : u?.role === "seller" ? "/seller" : "/";
        window.history.replaceState({}, "", dest);
        navigate(dest, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="jp-container py-20 text-center" data-testid="auth-callback">
      <p className="text-brand-muted">Signing you in…</p>
    </div>
  );
}
